import client from '@/api/client.js';
//import i18n from '@/plugins/i18n.js';
import store from "@/store";

export default {
    methods: {
        async getSampleFiles() {
            var meta = { clientApiMethod: 'getSampleFiles', input: {} };
            var response = await client().get(`${store.state.apiRouteRoot}Import/Samples`, { meta: meta });
            return response.data;
        },

        async getSampleFile(fileReuqestParams) {
            var meta = {
                clientApiMethod: 'getSampleFile',
                input: { fileReuqestParams: fileReuqestParams }
            };
            var response = await client().get(
                `${store.state.apiRouteRoot}Import/SampleFile`,
                { params: fileReuqestParams, meta: meta, responseType: 'arraybuffer' }
            );
            return response;
        },
        async uploadSampleFiles(files) {
            var formData = new FormData();
            var filenames = [];
            if (files) {
                for (var filekey in files) {
                    if (Object.prototype.hasOwnProperty.call(files, filekey)) {
                        const file = files[filekey];
                        formData.append("Files", file, file.name);
                        filenames.push(file.name);
                    }
                }
            }
            var meta = { clientApiMethod: 'uploadSampleFiles', input: { filenames: filenames } };

            var response = await client().post(`${store.state.apiRouteRoot}Import/SampleFiles`, formData, {
                headers: { "Content-Type": "multipart/form-data" },
                transformRequest: formData => formData,
                meta: meta
            });
            return response?.data;
        },
        async deleteSampleFile(fileReuqestParams) {
            var meta = { clientApiMethod: 'deleteSampleFile', input: { fileReuqestParams: fileReuqestParams } };
            var response = await client().delete(
                `${store.state.apiRouteRoot}Import/SampleFile`,
                { params: fileReuqestParams, meta: meta, }
            );
            return response;
        },

        async getImportedFiles() {
            var meta = { clientApiMethod: 'getImportedFiles', input: {} };
            var response = await client().get(`${store.state.apiRouteRoot}Import/Processed`, { meta: meta });
            return response.data;
        },

        async getImportedFile(fileReuqestParams) {
            var meta = {
                clientApiMethod: 'getImportedFile',
                input: { fileReuqestParams: fileReuqestParams },
            };
            var response = await client().get(
                `${store.state.apiRouteRoot}Import/File`,
                { params: fileReuqestParams, meta: meta, responseType: 'arraybuffer' }
            );
            return response;
        },

        async importFile(file) {
            var meta = { clientApiMethod: 'importFile', input: { filename: file.name } };

            let formData = new FormData();
            formData.append("file", file, file.name);

            var response = await client().post(`${store.state.apiRouteRoot}Import`, formData, {
                headers: { "Content-Type": "multipart/form-data" },
                transformRequest: formData => formData,
                meta: meta
            });
            return response?.data;
        },

    }
}